<!--
  功能：功能描述
  作者：Aaron
  时间：2024年04月12日 14:19:50
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="custom-menu">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      text-color="#fff"
      active-text-color="#000"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="item in $routerList"
        :key="item.id"
        :index="String(item.id)"
        >{{ item.name }}</el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "TopLevelMenu",
  props: {},
  components: {},
  data() {
    return {
      activeIndex: "",
    };
  },

  watch: {},
  methods: {
    handleSelect(item) {
      console.log(this.$routerList, "this.$routerList...");
      const subMenus =
        this.$routerList.find((menu) => menu.id == item).children || [];
      console.log(subMenus, "subMenus...");
      this.$store.commit("utils/SET_SUBROUTERLIST", subMenus);
      // this.$store.commit("utils/SET_ROUTERLIST", this.$routerList)
    },
  },
  created() {
    this.activeIndex = String(this.$routerList[0].id);
  },
};
</script>
<style lang="stylus" scoped>
.custom-menu {
  ::v-deep .el-menu {
    background-color: transparent;
    border-bottom: none !important;
  }
  ::v-deep .el-menu-item {
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: none !important;
    &:hover {
      background-color: #fff !important;
      color: $headBgColor !important;
    }
  }

  ::v-deep .el-menu-item.is-active {
    background-color: #fff !important;
    color: $headBgColor !important;
  }
}
</style>
